import { isDefined } from '@grandvisionhq/utils';
import { getConfigurationSpecificationItem } from './get-configuration-specification-item.js';

const getConfigurationSpecificationItems = (configuration, activeVariant, getLabel, locale)=>configuration.map((specification)=>getConfigurationSpecificationItem(specification, activeVariant, getLabel, locale)
    ).filter(isDefined)
;

export { getConfigurationSpecificationItems };
//# sourceMappingURL=get-configuration-specification-items.js.map
